<template>
  <svg
    :width="size"
    :height="size"
    :viewBox="`-${size * 0.125} -${size * 0.125} ${size * 1.25} ${size * 1.25}`"
    xmlns="http://www.w3.org/2000/svg"
    style="transform: rotate(-90deg)"
  >
    <circle
      :r="radius - 10"
      :cx="radius"
      :cy="radius"
      fill="transparent"
      stroke="#ccc"
      :stroke-width="strokeWidth"
      :stroke-dasharray="circumferenceText"
      stroke-dashoffset="0"
    />
    <circle
      :r="radius - 10"
      :cx="radius"
      :cy="radius"
      :stroke="color"
      :stroke-width="strokeWidth"
      fill="transparent"
      stroke-linecap="round"
      :stroke-dashoffset="percentage"
      :stroke-dasharray="circumferenceText"
    />

    <text
      ref="textRef"
      :x="textX"
      :y="textY"
      :fill="color"
      :font-size="fontSize"
      font-weight="bold"
      :style="`transform: rotate(90deg) translate(0px, -${size - 4}px)`"
    >
      {{ progress }}{{ showPercentage ? '%' : '' }}
    </text>
  </svg>
</template>

<script lang="ts">
import { clamp } from '@/helpers/clamp'
import { defineComponent, computed, ref, onMounted } from 'vue'

export default defineComponent({
  name: 'lp-loading-circle',
  props: {
    strokeWidth: { default: 6, type: Number },
    size: { default: 32, type: Number },
    color: { default: '#1A62FF', type: String },
    progress: { default: 0, type: Number },
    progressWidth: { default: 6, type: Number },
    showPercentage: { default: false, type: Boolean },
  },
  setup(props) {
    const circumferenceValue = computed(() => 3.14 * (props.size / 2 - 10) * 2)
    const circumferenceText = computed(() => `${circumferenceValue.value}px`)
    const percentage = computed(
      () =>
        `${Math.round(
          circumferenceValue.value * ((100 - props.progress) / 100),
        )}px`,
    )
    const textRef = ref<HTMLOrSVGImageElement | null>(null)
    const textDimensions = computed(() =>
      textRef.value ? textRef.value?.getBoundingClientRect() : 0,
    )
    const textX = computed(
      () =>
        `${Math.round(
          props.size / 2 -
            textDimensions.value.width / (props.showPercentage ? 1.75 : 1.5),
        )}px`,
    )
    const percentageTextX = computed(
      () =>
        `${Math.round(props.size / 2 + textDimensions.value.width / 2 + 10)}px`,
    )
    const textY = computed(
      () =>
        `${Math.round(props.size / 2 + textDimensions.value.height / 3.25)}px`,
    )
    const fontSize = computed(
      () =>
        `${clamp(
          props.size * 0.4,
          props.size * 0.1,
          props.showPercentage ? props.size * 0.3 : props.size * 0.4,
        )}px`,
    )
    const radius = computed(() => props.size / 2)
    onMounted(() => {
      console.log()
    })
    return {
      circumferenceValue,
      circumferenceText,
      percentage,
      percentageTextX,
      textX,
      textY,
      textRef,
      textDimensions,
      fontSize,
      radius,
    }
  },
})
</script>
